import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate, useParams } from "react-router-dom";
import userApi from "../../api/user/user.api";
import { toast } from "react-hot-toast"; // ✅ instead of react-toastify

import { useDispatch } from "react-redux";
import { setAuthModalOpen } from "../../redux/features/authModalSlice";
import { useEffect } from "react";

const ResetPasswordForm = () => {
  const { token } = useParams();

  const navigate = useNavigate();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setAuthModalOpen(false));
  }, [dispatch]);

  const formik = useFormik({
    initialValues: {
      password: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      password: Yup.string()
        .min(3, "Password must be at least 3 characters")
        .required("Password is required"),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("password")], "Passwords must match")
        .required("Confirm Password is required"),
    }),
    onSubmit: async (values) => {
      try {
        const { response } = await userApi.resetPassword(
          token,
          values.password
        );
        console.log({ response });
        if (response) {
          const message = response.data?.message || "Password reset successful";

          toast.success(message);

          setTimeout(() => {
            navigate("/");
            dispatch(setAuthModalOpen(true));
          }, 1000); // 2 seconds delay
        }
      } catch (error) {
        toast.error(error.response?.data?.message || "Reset failed");
      }
    },
  });

  return (
    <form
      onSubmit={formik.handleSubmit}
      className="flex flex-col gap-4 h-screen bg-dry items-center justify-center p-3"
    >
      <div className="p-6 mx-3 flex flex-col gap-8 sm:w-[50vw] w-full border border-yellowlight rounded-2xl">
        {/* New Password */}
        <div className="flex flex-col">
          <label htmlFor="password" className="text-white font-semibold">
            New Password
          </label>
          <input
            id="password"
            type="password"
            name="password"
            placeholder="New Password"
            value={formik.values.password}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className="p-3 bg-dry border border-border text-white rounded"
          />
          {formik.touched.password && formik.errors.password && (
            <span className="text-sm text-red-400 mt-1">
              {formik.errors.password}
            </span>
          )}
        </div>

        {/* Confirm Password */}
        <div className="flex flex-col">
          <label htmlFor="confirmPassword" className="text-white font-semibold">
            Confirm New Password
          </label>
          <input
            id="confirmPassword"
            type="password"
            name="confirmPassword"
            placeholder="Confirm New Password"
            value={formik.values.confirmPassword}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className="p-3 bg-dry border border-border text-white rounded"
          />
          {formik.touched.confirmPassword && formik.errors.confirmPassword && (
            <span className="text-sm text-red-400 mt-1">
              {formik.errors.confirmPassword}
            </span>
          )}
        </div>

        <button
          type="submit"
          className="bg-yellowlight hover:bg-yellowdark text-black py-2 rounded font-semibold"
        >
          Reset Password
        </button>
      </div>
    </form>
  );
};

export default ResetPasswordForm;
